import Thought from "../pages/Thought";
import Emotion from "../pages/Emotion";
import Situation from "../pages/Situation";
import ThinkingTraps from "../pages/ThinkingTraps";
import Reframe from "../pages/Reframe";
import Survey from "../pages/Survey";


const componentMap = {
    'Thought': Thought,
    'Emotion': Emotion,
    'Situation': Situation,
    'ThinkingTraps': ThinkingTraps,
    'Reframe': Reframe,
    'Survey': Survey
};

export {componentMap};